
export const filterNull = (value) => {
  if (value === null || value === '') {
    return '-'
  } else {
    return value
  }
}
